import { OnboardingFormFields } from '@Types/index';
import { reportActOnSlider } from '../OwnersCenterAnalytics';
import { usePercentageValidation } from './usePercentageValidation';
import type { ExtendedUseFormReturn } from '@Hooks/providers/useFormHooks';
import type { OwnersCenterFormType } from '../OwnersCenterForm/OwnersCenterForm.types';

export const useMainOwnerPercentage = (
  formMethods: ExtendedUseFormReturn<OwnersCenterFormType>
) => {
  const { validatePercentageChange, validateTotalPercentage } =
    usePercentageValidation(formMethods);

  const handleMainOwnerPercentageChange = async (value: number | null) => {
    reportActOnSlider(value);
    await validatePercentageChange(OnboardingFormFields.OWNER_PERCENTAGE);
  };

  return { handleMainOwnerPercentageChange, validateTotalPercentage };
};
